import React, { useState } from 'react';
import { FaCog } from 'react-icons/fa';

function Settings() {
  return (
    <div>
        <h3>< FaCog size={32}/> </h3>
    </div>
  );
}

export default Settings;